import { Injectable, inject } from '@angular/core';
import { HashStorageService } from '@df/browser/storage/hash-storage.service';
import { NProductConfiguration } from '@df/module-product-configuration/df-module-product-configuration.interfaces';
import isObject from 'lodash-es/isObject';
import omitBy from 'lodash-es/omitBy';

@Injectable()
export class ProductConfigurationConfigurableStorageService {
    /**
     * Services
     */
    private hashStorageService = inject(HashStorageService);
    private moduleConfig = inject(NProductConfiguration.OPTIONS);

    getHashParams(selection: NProductConfiguration.Configurable.Selection) {
        return omitBy(selection, (value, key) => {
            return value === undefined;
        });
    }

    /**
     * Write selection to hash storage
     */
    write(selection: NProductConfiguration.Configurable.Selection, hashKey?: string | false) {
        if (!hashKey) {
            return;
        }

        this.hashStorageService.set(hashKey, this.getHashParams(selection));
    }

    /**
     * Read selection from hash storage
     */
    read(hashKey?: string | false): NProductConfiguration.Configurable.Selection | undefined {
        if (!hashKey) {
            return undefined;
        }

        const selection = this.hashStorageService.get(hashKey);
        if (!selection || !isObject(selection)) {
            return undefined;
        }

        const cleanedSelection = omitBy(selection, (value, key) => {
            return typeof value !== 'number' || typeof key !== 'string';
        });

        return cleanedSelection as NProductConfiguration.Configurable.Selection;
    }
}
